export default "__VITE_ASSET__BOOBTL3B__"